import './App.css';
import { Outlet } from 'react-router-dom';
import SearchHeader from './components/SearchHeader';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { YoutubeApiProvider } from './context/YoutubeApiContext';

// 자식 요소를 보여줄 수 있도록 outlet을 설정한다.
const queryClient = new QueryClient();
function App() {
  return (
    <div className='d-flex w-100 vh-100 flex-column align-items-center bg-dark text-light'>
      <SearchHeader/>
      <YoutubeApiProvider>
      <QueryClientProvider client={queryClient}>
        <Outlet /> 
      </QueryClientProvider>
      </YoutubeApiProvider>
    </div>
    
);
}

export default App;
